import { useMutation, useQueryClient } from '@tanstack/react-query';

import { riskRangeApi } from '../api/risk-range.adapter';
import type { RiskRange } from '../types/risk-range.types';
import { riskRangeQueryKeys } from './use-risk-range';

export function useRiskRangeUpdateMutation() {
  const qc = useQueryClient();
  return useMutation<RiskRange, Error, RiskRange>({
    mutationFn: (range) => riskRangeApi.updateRange(range),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: riskRangeQueryKeys.range() });
    },
  });
}
